<template>
  <div class="user-main">
    <div class="user-main-head">
      <img data-track-text="返回账号设置" @click="clickHandler('/account')" style="margin-left: 28px" src="../assets/go-back.png" alt=""/>
      <div>修改密码</div>
    </div>
    <div class="main-login-form">
      <div class="main-login-form-input" v-show="!isSuccess">
        <el-form class="demo-ruleForm" :model="updatePassForm" ref="updatePassForm" :rules="updatePassFormRules">
          <el-form-item prop="oPass">
            <el-input type="password" v-model="updatePassForm.oPass" placeholder="原密码"></el-input>
          </el-form-item>
          <el-form-item prop="nPass">
            <el-input type="password" v-model="updatePassForm.nPass" placeholder="新密码"></el-input>
          </el-form-item>
          <el-form-item prop="aPass">
            <el-input type="password" v-model="updatePassForm.aPass" placeholder="确认密码"></el-input>
          </el-form-item>
          <el-form-item class="submit-row" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
            <span class="mobile-submit" style="padding: 20px 50px;
            background: #063f95;
            border-radius: 2px;
            font-size: 24px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: rgb(255, 255, 255);" data-track-text="确认修改密码" @click="submitUpadatePass">确认修改</span>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="isSuccess" class="success-state">
        <div>
          <div class="success-title" style="text-align: center;
    margin-top: 30%;
font-size: 36px;
font-family: Source Han Sans CN;
font-weight: 400;
color: #333333;
line-height: 56px;">
            <span class="icon-success"></span><span style="margin-left: 16px">重置成功</span>
          </div>
          <div class="success-action-wrap" style="    margin-left: 50%;
          transform: translate(-25%, 45px);">
            <div class="success-action" style="
            cursor: pointer;
            width: 200px;
            height: 60px;
            border: 1px solid #0c7dba;
            border-radius: 3px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 40px;
            font-size: 36px;
            font-family: Noto Sans S Chinese !important;
            font-weight: 400;
            color: #0c7dba;" data-track-text="修改成功返回" @click="clickHandler('/account')">返回
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RePass",
  data() {
    return {
      isSuccess: false,
      updatePassForm: {
        oPass: '',
        nPass: '',
        aPass: ''
      },
      updatePassFormRules: {
        oPass: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
        ],
        nPass: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
        ],
        aPass: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'},
          {validator: this.validatePass, trigger: 'blur'}
        ],
      },
    }
  },
  methods: {
    submitUpadatePass() {
      const that = this
      this.$track('account_password_update_submit', {source: 'mobile_page'})
      this.$refs.updatePassForm.validate((valid) => {
        if (!valid) {
          this.$track('account_password_update_result', {result: 'validation_failed', source: 'mobile_page'})
          return;
        }
        this.$http.get("/api/account/updatePass?oPass=" + this.updatePassForm.oPass + "&nPass=" + this.updatePassForm.nPass + "&aPass=" + this.updatePassForm.aPass).then(res => {
          if (res.data === 200) {
            that.$track('account_password_update_result', {result: 'success', source: 'mobile_page'})
            that.isSuccess = true
            that.messages = ""
            return;
          }
          if (res.data === 401) {
            that.$track('account_password_update_result', {result: 'failure', reason: 'old_password_rejected', source: 'mobile_page'})
            that.messages = "密码错误更新失败"
            return;
          }
          that.$track('account_password_update_result', {result: 'failure', source: 'mobile_page'})
          that.messages = "更新失败请重试！";
        }).catch(err => {
          that.$track('account_password_update_result', {result: 'failure', reason: 'request_failed', source: 'mobile_page'})
          that.messages = "更新失败请重试！";
        })
      });
    },
    validatePass(rule, value, callback) {
      if (this.updatePassForm.nPass !== value) {
        callback(new Error('两次密码输入不一致'))
        return;
      }
      callback()
    },
    clickHandler(url) {
      this.$router.push(url)
    },
  }
}
</script>

<style lang="less" scoped>

.timeButton {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #efeded;
  font-size: 21px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  color: #333333;
  display: flex;
  justify-content: center;
}

.timeButtonClick {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #0c7dba;
  font-size: 18px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  display: flex;
  justify-content: center;
  color: #ffffff;
}

.main-login-form {
  margin-top: 30px;
  margin-bottom: 30px;
  width: 704px;
  height: 1000px;
  background: #FFFFFF;
  padding-top: 60px;

  .main-login-form-input {
    width: 625px;
    display: flex;
    justify-content: center;

    /deep/ .demo-ruleForm {
      .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
        height: 65px;
        border: 1px solid #FBAFAF;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
      }

      .el-button--primary {
        width: 624px;
        height: 70px;
        background: #063f95;
        border-radius: 3px;
        margin-top: 31px;
        font-size: 30px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #FFFFFF;
      }

      .el-form-item__error {
        color: #F56C6C;
        font-size: 20px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
      }

      .el-form-item {
        margin-bottom: 31px;
      }

      .el-form-item__content {
        margin-left: 76px !important;
      }

      .el-input {
        height: 65px;
        width: 625px;

        .el-input__inner {
          height: 65px;
          border: 1px solid #DDDDDD;
          box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
          border-radius: 3px;
          font-size: 24px;
        }
      }
    }
  }
}

.user-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-x: hidden;
}

.user-main-head {
  width: 100%;
  height: 88px;
  background: #E6E6E6;
  display: flex;
  align-items: center;
}

.user-main-head div {
  flex: 1;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-right: 60px;
}

@media (max-width: 768px) {
  .user-main {
    min-width: 0;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .user-main-head {
    width: 100%;
    height: 56px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .user-main-head > img {
    width: 20px;
    height: 20px;
    margin-left: 0 !important;
    object-fit: contain;
  }

  .user-main-head div {
    margin-right: 20px;
    font-size: 17px;
  }

  .main-login-form {
    width: calc(100% - 24px);
    max-width: 100%;
    height: auto;
    min-height: calc(100vh - 92px);
    margin: 12px;
    padding: 28px 16px 96px;
    box-sizing: border-box;

    .main-login-form-input {
      width: 100%;
      max-width: 100%;
      display: block;
    }

    /deep/ .demo-ruleForm {
      width: 100%;
      max-width: 100%;

      .el-form-item {
        width: 100%;
        margin-bottom: 22px;
      }

      .el-form-item__content {
        width: 100%;
        margin-left: 0 !important;
      }

      .el-input {
        width: 100%;
        height: 44px;

        .el-input__inner {
          width: 100%;
          height: 44px;
          box-sizing: border-box;
          font-size: 15px;
        }
      }

      .el-form-item.is-error .el-input__inner,
      .el-form-item.is-error .el-input__inner:focus {
        height: 44px;
      }

      .el-form-item__error {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  /deep/ .submit-row .el-form-item__content {
    width: 100%;
  }

  .mobile-submit {
    width: 100%;
    height: 44px;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-size: 16px !important;
    cursor: pointer;
  }

  .success-state {
    width: 100%;
  }

  .success-title {
    margin-top: 32% !important;
    font-size: 24px !important;
    line-height: 36px !important;
  }

  .success-action-wrap {
    margin-left: 0 !important;
    transform: none !important;
    display: flex;
    justify-content: center;
  }

  .success-action {
    width: 150px !important;
    height: 44px !important;
    margin-top: 24px;
    font-size: 18px !important;
    line-height: 44px !important;
    box-sizing: border-box;
  }

  .main-login-form .main-login-form-input {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item__content,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input__inner {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
